/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { combineReducers } from 'redux';

import homeAnalyticsData from 'state/reducers/homeState/home_analytics_data';
import homeAnalyticsStatus from 'state/reducers/homeState/home_analytics_status';




/* ========== ~~~~~~~~~~ ROOT REDUCER ~~~~~~~~~~ ========== */
// COMBINE REDUCERS
// used to comhine all various reducers together into an easily accesible object
// utilized in store.js

const homeRootReducer = combineReducers({
    homeAnalyticsData,
    homeAnalyticsStatus,
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default homeRootReducer;
